// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {Button, Card, Col, Input, Modal, Row, Select, Switch, Table, Tag} from "antd";
import * as RoleBackend from "../../services/RoleBackend";
import * as OrganizationBackend from "../../services/OrganizationBackend";
import * as ApplicationBackend from "../../services/ApplicationBackend";
import * as UserBackend from "../../services/UserBackend";
import * as Setting from "../../conf/Setting";
import i18next from "i18next";
import RoleUserTransfer from "../../components/role/RoleUserTransfer";
import DepartmentSelectModal from "../../components/user/DepartmentSelectModal";
import {v4 as uuidv4} from "uuid";
import "./RoleEditPage.less";
import {AppstoreFilled, SyncOutlined} from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";

const {Option} = Select;
const {Search} = Input;

const ruleFields = [{value: "department", label: i18next.t("role:Department")}];
const ruleConditions = [{value: "equal", label: i18next.t("role:Equal")}];

class RoleEditPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      owner: props.match.params.owner,
      roleId: props.match.params.roleId,
      role: null,
      organizations: [],
      users: [],
      mode: props.location.mode !== undefined ? props.location.mode : "edit",
      pagination: {
        current: 1,
        pageSize: 10,
      },
      selectedRowKeys: [],
      selectedRows: [],
      searchText: "",
      operateEnable: false,
      tranferModalVisible: false,
      userTransferConfirmLoading: false,
      transferdUsers: [],
      modalVisible: false,
      confirmLoading: false,
      applications: [],
      selectedApps: [],

      operatingRuleId: "",
      userTranferModalVisible: false,
      roleRules: [],
      updateRoleUserLoading: false,

      enableRoleModalVisible: false,
    };
  }

  newRule(roleId) {
    return {
      uid: uuidv4(), // uuid
      roleId: roleId, // 对应的角色的Uid
      field: "", // 对用户的哪一个字段进行判断 目前只有"department"
      condition: "", // 关系判断 目前只有"equal"
      value: [], // 判断比较的值 目前只有部门判断，值为部门uid列表
    };
  }

  UNSAFE_componentWillMount() {
    this.getRole();
    this.getOrganizations();
    this.getRoleApps();
  }

  getRole() {
    RoleBackend.getRole(this.state.owner, this.state.roleId)
      .then((role) => {
        this.setState({
          role: role,
        });

        this.getApplications(role.owner);
        this.getRoleUsers(role.uid, {pagination: this.state.pagination});
        if (!role.isStaticRole) {
          this.getRoleRules(role.uid);
        }
      });
  }

  getOrganizations() {
    OrganizationBackend.getOrganizations(Setting.Admin)
      .then((res) => {
        if (res.msg === undefined) {
          const org = res.filter(organization => !Setting.isAdminOrganization(organization.uid)).reverse();
          this.setState({
            organizations: org,
          });
        } else {
          this.setState({
            organizations: [],
          });
        }
      });
  }

  getRoleUsers(roleId, params = {}) {
    const field = params.searchedColumn, value = this.state.searchText;
    const sortField = params.sortField, sortOrder = params.sortOrder;
    UserBackend.getRoleUsers(roleId, params.pagination.current,
      params.pagination.pageSize, field, value, sortField, sortOrder)
      .then((res) => {
        if (res.status === "ok") {
          this.setState({
            users: res.data,
            pagination: {
              ...params.pagination,
              total: res.data2,
            },
          });
        }
      });
  }

  getApplications(organId) {
    ApplicationBackend.getApplicationsByOrganization(Setting.Admin, organId)
      .then((res) => {
        if (res.msg === undefined) {
          this.setState({
            applications: res,
          });
        }
      });
  }

  getRoleApps() {
    RoleBackend.getRoleApps(this.props.match.params.owner, this.props.match.params.roleId)
      .then(res => {
        if (res.status === "ok") {
          const selectedApps = res.data.map(item => {
            return {
              key: item.appsId,
              label: item.appsName,
              value: item.appsName,
            };
          });
          this.setState({selectedApps: selectedApps});
        }
      });
  }

  getRoleRules(roleId) {
    RoleBackend.getRoleRules(this.props.match.params.owner, this.props.match.params.roleId)
      .then(res => {
        if (res.status === "ok") {
          if (res.data.length === 0) {
            const newRule = this.newRule(roleId);
            newRule.field = "department";
            newRule.condition = "equal";
            this.setState({roleRules: [newRule]});
          } else {
            this.setState({roleRules: res.data});
          }
        }
      });
  }

  parseRoleField(key, value) {
    if ([""].includes(key)) {
      value = Setting.myParseInt(value);
    }
    return value;
  }

  updateRoleField(key, value) {
    value = this.parseRoleField(key, value);

    const role = this.state.role;
    role[key] = value;
    this.setState({
      role: role,
    });
  }

  renderRole() {
    const titleStyle = {
      fontSize: 16,
      fontWeight: 600,
      marginTop: 32,
      marginBottom: 32,
      display: "flex",
      alignItems: "center",
    };

    const tagRender = (props) => {
      return (
        <Tag
          {...props}
          icon={<AppstoreFilled />}
        >
          {props.label}
        </Tag>
      );
    };

    const columns = [
      {
        title: i18next.t("general:Number"),
        dataIndex: "index",
        key: "index",
        width: (Setting.isMobile()) ? "60px" : "100px",
        fixed: "left",
        align: "center",
        render: (text, record, index) => `${index + 1}`,
      },
      {
        title: i18next.t("user:Name"),
        dataIndex: "name",
        key: "name",
        width: (Setting.isMobile()) ? "80px" : "160px",
        fixed: "left",
        ellipsis: true,
        render: (text, record, index) => {
          return <a onClick={() => {
            this.props.history.push({pathname: `/users/${record.owner}/${record.name}`, mode: "edit"});
          }}>{record.name}</a>;
        },
      },
      {
        title: i18next.t("user:Display name"),
        dataIndex: "displayName",
        key: "displayName",
        width: "140px",
        ellipsis: true,
      },
      {
        title: i18next.t("general:Phone"),
        dataIndex: "phone",
        key: "phone",
        width: "140px",
      },
      {
        title: i18next.t("general:Email"),
        dataIndex: "email",
        key: "email",
        width: "180px",
        ellipsis: true,
      },
      {
        title: i18next.t("general:Avatar"),
        dataIndex: "avatar",
        key: "avatar",
        width: "140px",
        align: "center",
        render: (text, record, index) => {
          return (
            <img src={text === "" ? require("../../assets/images/default_avatar.png") : text} alt={""} width={50} height={50} />
          );
        },
      },
      {
        title: i18next.t("user:Departments"),
        dataIndex: "department",
        key: "department",
        width: "180px",
        ellipsis: true,
      },
      {
        title: i18next.t("user:Activated"),
        dataIndex: "isActive",
        key: "isActive",
        width: "180px",
        filters: [
          {
            text: i18next.t("user:All State"),
            value: "2",
          },
          {
            text: i18next.t("user:Activated NO"),
            value: "0",
          },
          {
            text: i18next.t("user:Activated YES"),
            value: "1",
          },
        ],
        filterMultiple: false,
        render: (text, record, index) => {
          return record.isActive ? <div style={{width: 59, height: 24, background: "rgba(45, 120, 213, 0.20)",
            color: "#2D78D5", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: 2}}>{i18next.t("user:Activated YES")}</div>
            : <div style={{width: 59, height: 24, background: "rgba(255, 163, 65, 0.20)",
              color: "#FFA341", display: "flex", justifyContent: "center", alignItems: "center", borderRadius: 2}}>{i18next.t("user:Activated NO")}</div>;
        },
      },
    ];

    const paginationProps = {
      total: this.state.pagination.total,
      showQuickJumper: true,
      showSizeChanger: true,
      showTotal: () => i18next.t("general:{total} in total").replace("{total}", this.state.pagination.total),
    };

    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      onChange: (newSelectedRowKeys, newSelectedRows) => {
        this.setState({
          selectedRowKeys: newSelectedRowKeys,
          selectedRows: newSelectedRows,
          operateEnable: newSelectedRowKeys.length > 0 ? true : false,
        });
      },
    };

    const opButtonStyle = {
      minWidth: "70px",
      height: "32px",
      marginRight: "12px",
      borderRadius: "2px",
    };

    return (
      <Card size="small" title={
        <div>
          {this.state.mode === "add" ? (this.state.role.isStaticRole ? i18next.t("role:New static role") : i18next.t("role:New dynamic role")) :
            (this.state.role.isStaticRole ? i18next.t("role:Edit static role") : i18next.t("role:Edit dynamic role"))}&nbsp;&nbsp;&nbsp;&nbsp;
          <Button onClick={() => this.submitRoleEdit(false)}>{i18next.t("general:Save")}</Button>
          <Button style={{marginLeft: "20px"}} type="primary" onClick={() => this.submitRoleEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
          {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} onClick={() => this.deleteRole()}>{i18next.t("general:Cancel")}</Button> :
            <Button style={{marginLeft: "20px"}} onClick={() => this.exit()}>{i18next.t("general:Cancel")}</Button>
          }
        </div>
      } style={(Setting.isMobile()) ? {margin: "5px"} : {}} type="inner">
        <div style={titleStyle}>
          <div style={{backgroundColor: "#2D78D5", marginRight: 12, height: 24, width: 4, display: "inline-block"}}></div>
          {i18next.t("role:Basic")}
        </div>
        <Row style={{marginTop: "10px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("general:Organization"), i18next.t("general:Organization - Tooltip"), true)} :
          </Col>
          <Col span={22} >
            <Select disabled virtual={false} style={{width: "100%"}} value={this.state.role.owner} onChange={((value, option) => {
              this.updateRoleField("owner", value);
              this.updateRoleField("organName", option.children);
              this.getApplications(value);
              this.setState({selectedApps: []});
            })}>
              {
                this.state.organizations.map((organization, index) => <Option key={index} value={organization.uid}>{organization.displayName}</Option>)
              }
            </Select>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("role:Role name"), i18next.t("role:Role name - Tooltip"), true)} :
          </Col>
          <Col span={22} >
            <Input value={this.state.role.displayName} maxLength={50} showCount={true} onChange={e => {
              this.updateRoleField("displayName", e.target.value);
            }} />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("role:Access apps"), i18next.t("role:Access apps - Tooltip"))} :
          </Col>
          <Col span={22} >
            <Select virtual={false} mode="multiple" tagRender={tagRender} style={{width: "100%"}} value={this.state.selectedApps} labelInValue onChange={(value => {
              this.setState({selectedApps: value});
            })}>
              {
                this.state.applications.map((app, index) => <Option key={app.uid} value={app.displayName}>{app.displayName}</Option>)
              }
            </Select>
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 22 : 2}>
            {Setting.getLabel(i18next.t("role:Description"), i18next.t("role:Description - Tooltip"))} :
          </Col>
          <Col span={22} >
            <TextArea rows={4} placeholder={i18next.t("role:Please input description in 100 words")} value={this.state.role.describe} showCount={true} maxLength={100} onChange={e => {
              this.updateRoleField("describe", e.target.value);
            }}
            />
          </Col>
        </Row>
        <Row style={{marginTop: "20px"}} >
          <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 19 : 2}>
            {Setting.getLabel(i18next.t("role:Is enabled"), i18next.t("role:Is enabled - Tooltip"))} :
          </Col>
          <Col span={1} >
            <Switch checked={this.state.role.isEnabled} onChange={checked => {
              if (!checked) {
                this.setState({enableRoleModalVisible: true});
              } else {
                this.updateRoleField("isEnabled", checked);
              }
            }} />
          </Col>
        </Row>
        {
          this.state.role.isStaticRole ?
            null
            :
            <Row style={{marginTop: "20px"}} >
              <Col style={{marginTop: "5px"}} span={(Setting.isMobile()) ? 19 : 2}>
                {Setting.getLabel(i18next.t("role:Rule"), i18next.t("role:Rule - Tooltip"), true)} :
              </Col>
              <Col span={22} style={{paddingTop: 10}}>
                <Row type="flex" justify="start" style={{marginBottom: 10}}>
                  <Col span={4}>
                    <Row>{i18next.t("role:Property")}</Row>
                  </Col>
                  <Col span={4}>
                    <Row>{i18next.t("role:Relation")}</Row>
                  </Col>
                  <Col span={4}>
                    <Row>{i18next.t("role:Value")}</Row>
                  </Col>
                </Row>
                {
                  this.state.roleRules.map(rule => {
                    return <Row type="flex" justify="start" key={rule.uid}>
                      <Col span={4}>
                        <Select virtual={false} style={{width: "80%"}} value={rule.field} onChange={(value => {})}>
                          {
                            ruleFields.map((field, index) => <Option key={index} value={field.value}>{field.label}</Option>)
                          }
                        </Select>
                      </Col>
                      <Col span={4}>
                        <Select virtual={false} style={{width: "80%"}} value={rule.condition} onChange={(value => {})}>
                          {
                            ruleConditions.map((condition, index) => <Option key={index} value={condition.value}>{condition.label}</Option>)
                          }
                        </Select>
                      </Col>
                      <Col span={4}>
                        <div className="role-edit-tag-container" onClick={() => {
                          this.setState({operatingRuleId: rule.uid, userTranferModalVisible: true});
                        }}>
                          {
                            rule.value.map(dept => <Tag style={{marginTop: 5}} data-deptid={dept.deptId} key={dept.deptId} closable
                              onClose={(e) => {
                                e.preventDefault();
                                const removeId = e.currentTarget.parentNode.dataset.deptid;
                                const rules = this.state.roleRules.map(item => {
                                  if (rule.uid === item.uid) {
                                    const ruleValues = item.value.filter(range => range.deptId !== removeId);
                                    item.value = ruleValues;
                                  }
                                  return item;
                                });
                                this.setState({roleRules: rules});
                              }}>{dept.displayName}</Tag>)
                          }
                        </div>
                      </Col>
                    </Row>;
                  })
                }
              </Col>
            </Row>
        }
        {
          !this.state.role.isStaticRole && this.state.mode === "add" ?
            null
            :
            <>
              <div style={titleStyle}>
                <div style={{backgroundColor: "#2D78D5", marginRight: 12, height: 24, width: 4, display: "inline-block"}}></div>
                {i18next.t("role:Members")}
              </div>
              <Table
                className="user-table"
                scroll={{x: "100%", y: "calc(100vh - 319px)"}}
                columns={columns}
                dataSource={this.state.users}
                rowKey="id"
                size="middle"
                pagination={paginationProps}
                rowSelection={this.state.role.isStaticRole ? rowSelection : null}
                tableLayout="fixed"
                title={() => (
                  <>
                    <Row justify="space-between" style={{marginBottom: "8px"}}>
                      <Col>
                        <Search value={this.state.searchText}
                          onChange={(e) => {this.setState({searchText: e.target.value});}}
                          placeholder={i18next.t("user:Search placeholder")}
                          onSearch={() => {this.getRoleUsers(this.state.role.uid, {pagination: this.state.pagination});}}
                          allowClear={true}
                          style={{width: 250}} />
                      </Col>
                      {
                        this.state.role.isStaticRole ?
                          <Col>
                            <Button disabled={!this.state.operateEnable} style={opButtonStyle} type="primary" size="small"
                              ghost onClick={() => this.setState({modalVisible: true})}>{i18next.t("role:Remove user")}</Button>
                            <Button style={opButtonStyle} type="primary" size="small" onClick={() => this.showTransferUser()}>{i18next.t("role:Add user")}</Button>
                          </Col>
                          :
                          <Col>
                            <Button loading={this.state.updateRoleUserLoading} style={opButtonStyle}
                              type="primary" size="small" onClick={() => this.updateRoleUser()}><SyncOutlined />{i18next.t("role:Refresh")}</Button>
                          </Col>
                      }
                    </Row>
                  </>
                )}
                // loading={loading}
                onChange={() => {}}
              />
            </>
        }

        <Modal title={i18next.t("role:Confirm info")} visible={this.state.enableRoleModalVisible} onOk={() => {
          this.setState({enableRoleModalVisible: false});
          this.updateRoleField("isEnabled", false);
        }} onCancel={() => this.setState({enableRoleModalVisible: false})}>
          <p>{i18next.t("role:Sure to disable this role")}</p>
        </Modal>
        <DepartmentSelectModal visible={this.state.userTranferModalVisible}
          dismiss={() => this.setState({userTranferModalVisible: false})}
          confirmLoading={false}
          organId={this.state.role.owner}
          isOrgSelectDisabled={true}
          checkedIds={this.getRuleDepartments()}
          onConfirmSelect={(transferedNodes) => {
            const transferDepts = transferedNodes.map(node => {
              return {
                code: node.code, // 当前部门或组织的code
                deptId: node.uid, // 当前部门或组织的uid （必填）
                isDept: node.level === 0 ? false : true, // 是组织还是部门 0组织, 1部门 (必填)
                displayName: node.displayName,
                wholePath: node.wholePath,
              };
            });
            const rules = this.state.roleRules.map(item => {
              if (item.uid === this.state.operatingRuleId) {
                item.value = transferDepts;
              }
              return item;
            });

            this.setState({roleRules: rules, userTranferModalVisible: false});
          }}
        />

        <RoleUserTransfer visible={this.state.tranferModalVisible}
          dismiss={() => {this.setState({tranferModalVisible: false});}}
          confirmLoading={this.state.userTransferConfirmLoading}
          owner={this.state.role.owner}
          // defaultUsers={this.state.transferdUsers}
          onConfirmSelect={(transferedNodes) => {
            this.onTransferUser(transferedNodes);
          }}
        />
        <Modal
          title={i18next.t("role:Remove user")}
          visible={this.state.modalVisible}
          okText={i18next.t("general:Confirm")}
          cancelText={i18next.t("general:Cancel")}
          confirmLoading={this.state.confirmLoading}
          onOk={() => this.deleteRoleUsers()}
          onCancel={() => {this.setState({modalVisible: false});}}
        >
          <p>{i18next.t("role:Sure to remove users")}</p>
        </Modal>
      </Card>
    );
  }

  getRuleDepartments() {
    const rule = this.state.roleRules.find(item => item.uid === this.state.operatingRuleId);
    if (rule) {
      const departments = rule.value.map(item => item.deptId);
      return departments;
    }
    return [];
  }

  showTransferUser() {
    if (this.props.match.params.owner !== this.state.role.owner) {
      Modal.warning({
        title: "role:Info",
        content: i18next.t("role:Organization changed, please save first"),
      });
      return;
    }

    UserBackend.getRoleUsers(this.state.role.uid)
      .then((res) => {

        if (!res || res.msg === undefined) {
          this.setState({
            tranferModalVisible: true,
            transferdUsers: res ? res : [],
          });
        }
      });
  }

  onTransferUser(transferedNodes) {
    const users = transferedNodes.map(item => {
      return {
        usersId: item.id,
        usersName: item.displayName,
      };
    });
    this.setState({userTransferConfirmLoading: true});
    RoleBackend.addRoleUsers(this.props.match.params.owner, this.props.match.params.roleId, this.state.role.displayName, users)
      .then(res => {
        this.setState({userTransferConfirmLoading: false});
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("role:Users added successfully"));
          this.getRoleUsers(this.state.role.uid, {pagination: this.state.pagination});
          this.setState({tranferModalVisible: false});
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }).catch(error => {
        this.setState({userTransferConfirmLoading: false});
        Setting.showResponseMessage(error);
      });
  }

  updateRoleUser() {
    this.setState({updateRoleUserLoading: true});
    RoleBackend.updateRoleUser(this.props.match.params.owner, this.props.match.params.roleId)
      .then(res => {
        this.setState({updateRoleUserLoading: false});
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("role:Updated successfully"));
          this.getRoleUsers(this.state.role.uid, {pagination: this.state.pagination});
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }).catch(error => {
        this.setState({updateRoleUserLoading: false});
        Setting.showResponseMessage(error);
      });
  }

  async submitRoleEdit(willExist) {
    if (this.state.role.displayName.trim() === "") {
      Setting.showMessage("error", i18next.t("role:Displayname required"));
      return;
    }

    if (this.state.role.displayName.length > 50) {
      Setting.showMessage("error", i18next.t("role:Displayname limited 50 words"));
      return;
    }

    const foundIndex = this.state.roleRules.findIndex(item => {
      return item.value.length === 0;
    });

    if (foundIndex !== -1) {
      Setting.showMessage("error", i18next.t("role:Rule value required"));
      return;
    }

    const apps = this.state.selectedApps.map(item => {
      return {
        appsId: item.key,
        appsName: item.label,
      };
    });
    const role = Setting.deepCopy(this.state.role);
    // eslint-disable-next-line unused-imports/no-unused-vars
    const {userNum, ...restObject} = role;
    const resApp = await RoleBackend.setRoleApps(this.props.match.params.owner, this.props.match.params.roleId, this.state.role.displayName, apps);
    if (resApp.msg === "") {
      if (!this.state.role.isStaticRole) {
        const resRule = await RoleBackend.setRoleRules(this.props.match.params.owner, this.props.match.params.roleId, this.state.roleRules);
        if (resRule.status !== "ok") {
          Setting.showResponseMessage(resRule.msg);
          return;
        }
      }
      const resUpdate = await RoleBackend.updateRole(this.props.match.params.owner, this.props.match.params.roleId, restObject);
      if (resUpdate.status === "ok") {
        Setting.showMessage("success", i18next.t("general:Successfully saved"));

        if (willExist) {
          this.props.history.push("/roles");
        } else {
          this.setState({mode: "edit"});
          this.props.history.replace(`/roles/${this.state.role.owner}/${this.state.role.uid}`);
        }
      } else {
        Setting.showResponseMessage(resUpdate.msg);
      }
    } else {
      Setting.showResponseMessage(resApp.msg);
    }
  }

  deleteRole() {
    RoleBackend.deleteRole(this.state.role)
      .then(() => {
        this.props.history.push("/roles");
      })
      .catch(error => {
        Setting.showResponseMessage(error);
      });
  }

  exit() {
    this.props.history.goBack();
  }

  deleteRoleUsers() {
    const users = this.state.selectedRows.map(item => {
      return {
        usersId: item.id,
        usersName: item.displayName,
      };
    });
    this.setState({confirmLoading: true});
    RoleBackend.deleteRoleUsers(this.props.match.params.owner, this.props.match.params.roleId, users)
      .then(res => {
        this.setState({confirmLoading: false});
        if (res.status === "ok") {
          Setting.showMessage("success", i18next.t("role:Users removed successfully"));
          this.setState({modalVisible: false});
          this.getRoleUsers(this.state.role.uid, {pagination: this.state.pagination});
        } else {
          Setting.showResponseMessage(res.msg);
        }
      }).catch(error => {
        this.setState({confirmLoading: false});
        Setting.showResponseMessage(error);
      });
  }

  render() {
    return (
      <div>
        {
          this.state.role !== null ? this.renderRole() : null
        }
        <div style={{marginTop: "20px", marginLeft: "40px"}}>
          <Button size="large" onClick={() => this.submitRoleEdit(false)}>{i18next.t("general:Save")}</Button>
          <Button style={{marginLeft: "20px"}} type="primary" size="large" onClick={() => this.submitRoleEdit(true)}>{i18next.t("general:Save & Exit")}</Button>
          {this.state.mode === "add" ? <Button style={{marginLeft: "20px"}} size="large" onClick={() => this.deleteRole()}>{i18next.t("general:Cancel")}</Button> :
            <Button style={{marginLeft: "20px"}} onClick={() => this.exit()}>{i18next.t("general:Cancel")}</Button>}
        </div>
      </div>
    );
  }
}

export default RoleEditPage;
